export default "__VITE_ASSET__DOV87QSj__"